import { render, staticRenderFns } from "./directive.vue?vue&type=template&id=71b0e980&"
import script from "./directive.vue?vue&type=script&lang=js&"
export * from "./directive.vue?vue&type=script&lang=js&"
import style0 from "./directive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports